import { capitalize, omit } from 'lodash-es';
import { CardAddress, CardDieCut } from './routes/CardCustomizer/CardCustomizer.types';

export const isValidCardAddress = (address?: CardAddress) => {
  if (!address) {
    return false;
  }

  return Object.values(omit(address, ['address2'])).every(Boolean);
};

export const themeIdToTitle = (themeId: string) => themeId.split('_').map(capitalize).join(' ');

export const cardDieCutToBorderRadius = (shape: CardDieCut) => `${shape === CardDieCut.rounded ? 54 / 16 : 0}em`;
